<template lang='pug'>
  i.svg-icon.svg-icon-upload
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )

      path(d='M78.307,41.059C75.689,26.999,64.008,16.393,50,16.393c-11.122,0-20.763,6.704-25.593,16.492 c-11.565,1.329-20.59,11.73-20.59,24.381c0,13.55,10.333,24.523,23.091,24.523h50.031c10.622,0,19.243-9.155,19.243-20.437 C96.183,50.562,88.273,41.815,78.307,41.059z M57.697,53.177v16.35H42.303v-16.35H30.757L50,32.742l19.243,20.436L57.697,53.177 L57.697,53.177z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>